import { render, staticRenderFns } from "./customeTable.vue?vue&type=template&id=17574545"
import script from "./customeTable.vue?vue&type=script&lang=js"
export * from "./customeTable.vue?vue&type=script&lang=js"
import style0 from "./customeTable.vue?vue&type=style&index=0&id=17574545&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports